<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>我的信息交流</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>
                        <span>我的信息交流</span>
                        <span class="downloadCount">专报可下载 <i>{{ downloadCount }}</i> 次</span>
                        <!-- <button class="addUpload" @click="goUpload()"><i class="el-icon-circle-plus"></i>添加</button> -->
                    </h3>
                    <el-divider></el-divider>
                    <el-table
                        class="theadTable"
                        :data="tableData"
                        stripe>
                        <el-table-column
                            label="ID"
                            width="80"
                            prop="ProjectId">
                        </el-table-column>
                        <el-table-column
                            label="标题"
                            min-width="360"
                            prop="Name">
                        </el-table-column>
                        <el-table-column
                            label="分类"
                            width="100">
                            <template slot-scope="scope">
                                {{ scope.row.Invest}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="提交人"
                            width="120"
                            prop="ProjectName">
                        </el-table-column>
                        <el-table-column
                            label="状态"
                            width="100">
                            <template slot-scope="scope">
                                {{ scope.row.CheckStatus | checkStatus}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="120">
                            <template slot-scope="scope">
                                <!-- <el-button class="textBtn" @click="goDetail(scope.row)" type="text" size="small">详情</el-button> -->
                                <el-button class="textBtn" @click="goEdit(scope.row)" type="text">编辑</el-button>
                                <el-button class="textBtn" @click="goReason(scope.row)" type="text" v-if="scope.row.CheckStatus == '-10'">查看原因</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    getListbyfaqiren,
    getDownCount
} from '@services/tokenService.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name: '',
    components: { PersonCenterMenu },
    data() {
        return {
            companyId: '',
            infoTyeList: [
            {
                    label: '共享信息',
                    value: '10'
                },
                {
                    label: '专报信息',
                    value: '-10'
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            downloadCount: 0,
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        }
        this.companyId = getCookie('companyId');
        this.companyId = this.companyId === null ? '': this.companyId;
        this.getListbyfaqiren();
        this.getDownCount();
    },
    methods: {
        getDownCount() {
            let params = {
                accountid: this.accountId,
            };
            getDownCount(params).then(res => {
                if (res.Code == 1) {
                    this.downloadCount = res.Data;
                } else {
                    this.$message.error("专报下载次数请求失败");
                }
            })
        },
        getListbyfaqiren() {
            let params = {
                accountid: this.accountId,
                companyid: this.companyId,
                current: this.currentPage,
                size: this.pageSize,
            };
            getListbyfaqiren(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    // this.tableData.map(item => {
                    //     item.CheckStatus = '-10';
                    //     return item
                    // })
                    // console.log(this.tableData)
                    this.total = res.Count;
                } else {
                    this.$message.error("我的信息交流请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getListbyfaqiren();
        },
        goUpload() {
            this.$router.push(
                {
                    path:'/layout/upload-info',
                }
            );
        },
        goDetail(row) {

        },
        goReason(data) {
            this.$alert(data.FailReason, '原因', {
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
        },
        goEdit(data) {
            if (data.Invest === '专报信息') {
                this.$router.push(
                    {
                        path:'/layout/upload-special-info',
                        query: {
                            id: data.ProjectId,
                        }
                    }
                );
            } else if (data.Invest === '共享信息') {
                this.$router.push(
                    {
                        path:'/layout/upload-info',
                        query: {
                            id: data.ProjectId,
                        }
                    }
                );
            }
        },
        deleteData(data) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    filters: {
        checkStatus(values) {
            if (values === null) {
                return '';
            }
            let checkStatusList = [
                {
                    label: '审核通过',
                    value: '10'
                },
                {
                    label: '审核失败',
                    value: '-10'
                },
                {
                    label: '待审核',
                    value: '0'
                },
            ];
            for(let i=0;i<checkStatusList.length;i++) {
                if (checkStatusList[i].value == values) {
                    return checkStatusList[i].label;
                }
            }
            return '';
        }
    }
};
</script>

<style scoped>
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: left;
    margin-bottom: 0;
    padding-bottom: 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.theadTable {
    box-shadow: -2px -2px 16px 1px #00000026;
    margin-bottom: 30px;
}
.vertical-nav li a.active {
    border-left: none;
}
.textBtn {
    color: #2e8cd8;
}
.downloadCount {
    font-size: 16px;
    font-weight: normal;
}
.downloadCount i {
    font-style:normal;
    color: #F56C6C;
}
</style>